/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { FC, useCallback, useContext, useEffect, useState } from 'react'

import { Button, Col, Image, Layout, Menu, Row, Statistic } from 'antd'
import { countdownValueType } from 'antd/lib/statistic/utils'
import logo from 'Assets/Brand/logo.png'
import ID_COMPONENTE from 'config/idComponente'
import { ApplicationContext } from 'Context'
import { MenuGroup } from 'Models/cadastros/Menu'
import moment from 'moment'
import env from 'react-dotenv'
import { useNavigate } from 'react-router-dom'
import handleToken from 'Services/handleToken'
import WS_DOCAS from 'Services/WS_DOCAS'
import swal from 'sweetalert'
const { Header } = Layout
const { SubMenu } = Menu

let sessaoRenovada: boolean | undefined

const HeaderApp: FC = () => {
  const { Countdown } = Statistic
  const navigate = useNavigate()
  const [menuItens, setMenuItens] = useState<MenuGroup[]>()
  const [current, setCurrent] = useState<string[] | undefined>()
  const [modoDebug] = useState<boolean>(env.MODO_DEBUG === 'true')
  const [urlPortalMisto, setUrlPortalMisto] = useState<string>('')
  const [tempoSessaoMs, setTempoSessaoMs] = useState<number>()
  const { applicationContext, setApplicationContext } =
    useContext(ApplicationContext)

  // const getItensMenu = useCallback(async () => {
  //   const { data } = await WS_CADASTRO.menu.getItens()
  //   setMenuItens(data)
  // }, [])

  // useEffect(() => {
  //   getItensMenu()
  // }, [getItensMenu])

  const handleClick = (e: any) => {
    setCurrent(e.key)
  }

  const calculaTempoSessaoMs = () => {
    if (
      applicationContext.tempoSessaoMs &&
      applicationContext.dataInicioSessao
    ) {
      const dataAtual: Date = new Date()

      setTempoSessaoMs(
        applicationContext.tempoSessaoMs -
          (dataAtual.getTime() - applicationContext.dataInicioSessao.getTime()),
      )
    }
  }

  const verificaUrlPortalMisto = () => {
    const cdEntidadeSistema: number | undefined =
      applicationContext.usuarioAtual?.cdEntidadeSistema

    if (cdEntidadeSistema) {
      let urlPortalMisto: string =
        env[`URL_PORTAL_MISTO_ENTIDADE_SISTEMA_${cdEntidadeSistema}`]

      if (urlPortalMisto[urlPortalMisto.length - 1] !== '/') {
        urlPortalMisto += '/'
      }

      setUrlPortalMisto(urlPortalMisto)
    }

    return urlPortalMisto
  }

  const verificaSessao = (tempoRestanteMs: any) => {
    if (tempoRestanteMs <= 60000 && sessaoRenovada === undefined) {
      sessaoRenovada = false

      swal({
        title: 'Sessão Expirando',
        text: 'Falta menos de 1 minuto para a sua sessão expirar. Deseja voltar à tela inicial para renová-la?',
        icon: 'warning',
        buttons: ['NÃO', 'SIM'],
        dangerMode: true,
      }).then((renovarSessao) => {
        if (renovarSessao) {
          sessaoRenovada = true

          setApplicationContext({
            ...applicationContext,
            tempoSessaoMs: undefined,
            dataInicioSessao: undefined,
          })
        } else {
          sessaoRenovada = false
        }
      })
    }
  }

  const finalizaSessao = () => {
    window.location.href = `${urlPortalMisto}Login/Logout`
  }

  useEffect(() => {
    verificaUrlPortalMisto()
  }, [])

  useEffect(() => {
    if (sessaoRenovada) {
      window.location.href = `${urlPortalMisto}Inicial?renovarSessao`
    } else {
      try {
        calculaTempoSessaoMs()
      } catch (e) {
        const tempoSessaoMs: string | null =
          window.sessionStorage.getItem('tempoSessaoMs')
        const dataInicioSessao: string | null =
          window.sessionStorage.getItem('dataInicioSessao')

        if (tempoSessaoMs && dataInicioSessao) {
          setApplicationContext({
            ...applicationContext,
            tempoSessaoMs: window.parseInt(tempoSessaoMs),
            dataInicioSessao: new Date(dataInicioSessao),
          })
        }
      }
    }
  }, [applicationContext.dataInicioSessao])

  // TODO: Ajustar o design do menu
  return (
    <Header
      style={{
        position: 'fixed',
        zIndex: 2,
        width: '100%',
        background: '#2f4050',
        height: '64px',
      }}
    >
      <Row gutter={24}>
        <Col
          style={{
            height: '55px',
          }}
        >
          <Image
            preview={false}
            src={logo}
            width={200}
            alt="Logo compulog"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              window.location.href = urlPortalMisto
            }}
          />
        </Col>

        {tempoSessaoMs && (
          <Col>
            <div
              style={{
                color: '#19aa8d',
                display: 'inline-block',
                fontSize: '14px',
                marginRight: '5px',
              }}
            >
              Tempo de Sessão:
            </div>
            <Countdown
              // title={
              //   <div style={{ color: '#19aa8d', display: 'inline-block' }}>
              //     Tempo de Sessão:
              //   </div>
              // }
              value={Date.now() + tempoSessaoMs}
              onChange={verificaSessao}
              onFinish={finalizaSessao}
              style={{ display: 'inline-block' }}
              valueStyle={{
                color: '#19aa8d',
                fontSize: '14px',
              }}
            />
          </Col>
        )}

        {modoDebug && (
          <Col push={15}>
            <Button
              type="primary"
              onClick={() => {
                setApplicationContext({})
                navigate('/')
              }}
            >
              Sair (Este botao so aparece no Modo Debug)
            </Button>
          </Col>
        )}
      </Row>
    </Header>
  )
}

export default HeaderApp
